import {Component, CUSTOM_ELEMENTS_SCHEMA, input, output, signal} from '@angular/core';
import {ComparableMatch} from '../../../models/valuation-comparable.models';
import {CurrencyPipe, DecimalPipe, NgTemplateOutlet} from '@angular/common';
import {SignedDiffPipe} from '../../../shared/pipes/signed-diff.pipe';
import {StackComponent} from '../../../shared/components/stack/stack.component';

@Component({
  selector: 'app-comparable',
  imports: [
    CurrencyPipe,
    DecimalPipe,
    SignedDiffPipe,
    StackComponent,
    NgTemplateOutlet
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './comparable.component.html',
  styleUrl: './comparable.component.css'
})
export class ComparableComponent {
  readonly comparable = input.required<ComparableMatch>();
  readonly toggle = output<boolean>()
  protected readonly collapsed = signal(true);
}
